const { Modal } = require("./common");
const { ajaxHandler, spinnerElem, toast, debounce } = require("./utilities/utilities");

/**
 * Subscription template script
 *
 * @since 1.0.0
 */
document.addEventListener('DOMContentLoaded', function () {
    const upgradeModelElem      = document.getElementById('subscription-upgrade-modal');
    const upgradeModalBootstrap = upgradeModelElem ? new Modal(upgradeModelElem) : null;

    const contentWrapper = document.querySelector('.subscriptions');
    const { vendor_id, environment, current_user, client_side_token } = platformObject;
    const couponCodeElem = document.getElementById('promotion-code');

    if (contentWrapper) {
        contentWrapper.addEventListener('click', async (e) => {
            const target = e.target;
            if (!target.hasAttribute('class')) {
                return;
            }
            const classNames = target?.className.split(' ');

            if (classNames.includes('plan-auto-renew')) {
                e.preventDefault();

                const paddleSubscriptionId = target.dataset.paddleSubscriptionId;
                const subscriptionId       = target.dataset.subscriptionId;
                const planId               = target.dataset.planId;
                // Cancel subscription logic
                if (target.checked) {
                    // Check if the target elem is checked.
                    updateAutoRenew(planId, paddleSubscriptionId, subscriptionId, target, target.checked);
                } else {
                    if (confirm('Do you really want to proceed?')) {
                        updateAutoRenew(planId, paddleSubscriptionId, subscriptionId, target, target.checked);
                    }
                }
            }

            // Handle upgrade event
            if (classNames.includes('subscription-upgrade')) {
                e.preventDefault();

                const subscriptionId = target.dataset.subscriptionId
                const planId = target.dataset.planId;

                const prevHTML = target.innerHTML;

                if (upgradeModalBootstrap) {
                    const formData = new FormData();
                    formData.set('action', 'products_subscription_upgradeable_plans');
                    formData.set('subscription_id', subscriptionId);
                    formData.set('plan_id', planId);

                    // Send request
                    try {
                        // Disable btn and show spinner
                        target.innerHTML = `${spinnerElem}`;
                        target.setAttribute('disabled', true);

                        const res = await ajaxHandler(formData);
                        if (res) {
                            const { success, data } = res;
                            if (success) {
                                document.querySelector('#subscription-upgrade-modal form').innerHTML = data;
                                upgradeModalBootstrap.open();
                            } else {
                                toast.error(data);
                            }
                        } else {
                            toast.error('Something went wrong! Please try again later.');
                        }
                    } catch (error) {
                        toast.error(error);
                    } finally {
                        target.innerHTML = `${prevHTML}`;
                        target.removeAttribute('disabled');
                    }
                }
            }

            if (classNames.includes('subscription-pay-now')) {
                e.preventDefault();
                const subscriptionId = target.dataset.subscriptionId;

                // Payment logic
                payNow(subscriptionId, target);
            }

            if (classNames.includes('subscription-cancel')) {
                e.preventDefault();
                const subscriptionId = target.dataset.subscriptionId;
                const cancelModal = document.getElementById('subscription-cancel-modal');

                if (cancelModal) {
                    const confirmButton = cancelModal.querySelector("#confirm-cancel-subscription");
                    if (confirmButton) {
                        confirmButton.dataset.subscriptionId = subscriptionId;
                        confirmButton.dataset.paddleApiType  = target.dataset.paddleApiType;
                    }
                    new Modal(cancelModal).open();
                }
            }

            /**
             * Update Subscription Payment Method Details
             */
            if (classNames.includes('subscription-update-payment-method')) {
                e.preventDefault();

                let targetElement = document.querySelector(".platform-update-payment-method-dropdown-btn");
                const prevHTML    = targetElement.innerHTML;          

                try {

                    // Disable btn and show spinner
                    targetElement.innerHTML = spinnerElem;

                    const formData = new FormData();

                    formData.set('action', 'platform_update_payment_method');
                    formData.set('paddle_subscription_id', target.dataset.paddleSubscriptionId);
                    formData.set('paddle_plan_id', target.dataset.paddlePlanId);

                    const res = await ajaxHandler(formData);

                    if (res?.success) {
                        window.open(res.data, '_blank');

                    } else {
                        toast.error( res?.data || 'Something went wrong! Please try again later.' + error);
                    }
                } catch (error) {
                    toast.error('Error: ' + error);
                } finally {
                    targetElement.innerHTML = prevHTML;
                }
            }
        });

    }

    // Confirm cancel subscription
    const confirmCancel = document.querySelector("#confirm-cancel-subscription");
    if (confirmCancel) {
        confirmCancel.addEventListener('click', async function (e) {
            const target = e.target;

            const prevHTML = target.innerHTML;
            const subscriptionId = target.dataset.subscriptionId;

            const formData = new FormData();
            formData.set('action', 'products_subscription_cancel');
            formData.set('subscription_id', subscriptionId);
            formData.set('paddle_api_type', target.dataset.paddleApiType);

            try {
                target.innerHTML = `${spinnerElem}`;
                target.setAttribute('disabled', true);

                const res = await ajaxHandler(formData);
                if (res) {
                    const { success, data } = res;
                    if (success) {
                        toast.success(data);
                        window.location.reload();
                    } else {
                        toast.error(data);
                    }
                } else {
                    toast.error('Something went wrong! Please try again later.');
                }
            } catch (error) {
                toast.error(error);
            } finally {
                target.innerHTML = `${prevHTML}`;
                target.removeAttribute('disabled');
            }
        })
    }

    // Handle subscription event for pricing page
    const checkoutForm = document.getElementById("guest-checkout-form");
    const guestSubscribePlan = document.querySelector('button[action-guest-subscribe-plan]');
    if (guestSubscribePlan) {
        guestSubscribePlan.addEventListener('click', (e) => {
            e.preventDefault();
            checkoutForm.querySelector('button[type="submit"]').click();
        })
    }

    if (checkoutForm) {
        checkoutForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            const paddlePlanId = guestSubscribePlan.dataset.paddlePlanId; // Payment gateway plan
            const planId = guestSubscribePlan.dataset.planId; // Payment gateway plan
            const couponCode = couponCodeElem ? couponCodeElem.value : '';
            const paddleApiType = guestSubscribePlan.dataset.paddleApiType;

            const formData = new FormData(checkoutForm);
            formData.set('paddle_plan_id', paddlePlanId);
            formData.set('plan_id', planId);
            formData.set('action', 'products_subscription');
            formData.set('paddle_api_type', paddleApiType);
            if (couponCode) {
                formData.set('coupon_code', couponCode);
            }

            const guestSubscribeBtnPrevHTML = guestSubscribePlan.innerHTML;

            try {
                guestSubscribePlan.innerHTML = `${spinnerElem}`;
                guestSubscribePlan.setAttribute('disabled', true);
                const res = await ajaxHandler(formData);

                if (res) {
                    const { success, data } = res;
                    if (success) {
                        (paddleApiType === 'classic') ? openPaddleCheckout(data) : openPaddleCheckoutForBilling(data)
                    } else {
                        toast.error(data);
                    }
                }
            } catch (error) {
                toast.error(error);
            } finally {
                guestSubscribePlan.innerHTML = guestSubscribeBtnPrevHTML;
                guestSubscribePlan.removeAttribute('disabled');
            }
        })
    }


    const subscribePlan = document.querySelector('button[action-subscribe-plan]');
    if (subscribePlan) {
        subscribePlan.addEventListener('click', (e) => {
            e.preventDefault();

            let target = e.target;
            if (target.tagName === 'svg') {
                target = target.closest('button');
            }
    
            const paddlePlanId = target.dataset.paddlePlanId; // Payment gateway plan
            const planId = target.dataset.planId; // Payment gateway plan
            const couponCode = couponCodeElem ? couponCodeElem.value : '';

            handleSubscription(paddlePlanId, planId, couponCode, target);
        })
    }

    // Handle add promotion code in checkout
    const addPromotionButton = document.getElementById('add-promotion-code');
    const addPromotionInput = couponCodeElem;
    if (addPromotionButton) {
        addPromotionButton.addEventListener('click', () => {
            addPromotionButton.remove();
            addPromotionInput.classList.remove('platform-d-none');
            addPromotionInput.focus();
        })
    }

    // Apply coupon
    const couponField = couponCodeElem;
    if (couponField) {
        const promotionSpinner = document.getElementById('promotion-spinner');
        const existingTotalPrice = document.getElementById('total-price').innerHTML;
        const checkoutDiscount = document.getElementById('checkout-discount');
        const planPriceElement = document.getElementById('platform-plan-price');
        const deletedPriceElement = document.getElementById('platform-deleted-price');

        const successAlert = document.querySelector(".platform-alert.platform-alert-success");
        const dangerAlert = document.querySelector(".platform-alert.platform-alert-danger");

        const debouncedHandler = debounce(async (e) => {
            const target = e.target;
            const couponCode = target.value;
            const planId = target.dataset.planId;
            if (couponCode) {
                promotionSpinner.classList.remove('platform-d-none');

                const formData = new FormData();
                formData.set('action', 'products_apply_coupon');
                formData.set('coupon_code', couponCode);
                formData.set('plan_id', planId);

                // Send request
                try {
                    const res = await ajaxHandler(formData);
                    if (res.success) {
                        const { success, data } = res;
                        if (success) {
                            const regularPrice = parseFloat(data.regular_price?.replace(/,/g, '')) || 0;
                            const couponPrice = parseFloat(data.coupon_price?.replace(/,/g, '')) || 0;
                            const discountAmount = regularPrice - couponPrice;
                            const discountPrice = `-$${discountAmount.toLocaleString()} ${data?.coupon_details.discount_type === 'percentage' ? `(${data?.coupon_details.discount_value}%)` : ''}`;

                            checkoutDiscount.classList.remove('platform-d-none');
                            document.getElementById('total-price').innerHTML = `$${data.coupon_price}`;
                            document.getElementById('discount-price').innerHTML = discountPrice;

                            planPriceElement.innerHTML = `$${data.regular_price}`;
                            deletedPriceElement?.classList.add('platform-d-none');

                            successAlert.innerHTML = data.message;
                            successAlert.classList.remove('platform-d-none');
                            dangerAlert.classList.add('platform-d-none');
                        } else {
                            document.getElementById('total-price').innerHTML = `$${data.regular_price}`;
                            checkoutDiscount.classList.add('platform-d-none');
                            dangerAlert.innerHTML = data.message;
                            dangerAlert.classList.remove('platform-d-none');
                            successAlert.classList.add('platform-d-none');

                            planPriceElement.innerHTML = planPriceElement.dataset.price;
                            deletedPriceElement?.classList.remove('platform-d-none');
                        }
                    } else {
                        checkoutDiscount.classList.add('platform-d-none');
                        dangerAlert.innerHTML = res?.data?.message || 'Something went wrong! Please try again later.';
                        dangerAlert.classList.remove('platform-d-none');
                        successAlert.classList.add('platform-d-none');

                        planPriceElement.innerHTML = planPriceElement.dataset.price;
                        deletedPriceElement?.classList.remove('platform-d-none');
                    }
                } catch (error) {
                    checkoutDiscount.classList.add('platform-d-none');
                    dangerAlert.innerHTML = error;
                    dangerAlert.classList.remove('platform-d-none');
                    successAlert.classList.add('platform-d-none');

                    planPriceElement.innerHTML = planPriceElement.dataset.price;
                    deletedPriceElement?.classList.remove('platform-d-none');
                }
                promotionSpinner.classList.add('platform-d-none');
            } else {
                document.getElementById('total-price').innerHTML = existingTotalPrice;
                checkoutDiscount.classList.add('platform-d-none');
                successAlert.classList.add('platform-d-none');
                dangerAlert.classList.add('platform-d-none');

                planPriceElement.innerHTML = planPriceElement.dataset.price;
                deletedPriceElement?.classList.remove('platform-d-none');
            }
        }, 500);

        // Attach the debounced event handler to the input event
        couponField.addEventListener('input', debouncedHandler);
    }

    /**
     * Handles the click event for the 'Pay Now' button and initiates the payment process.
     */
    const subscriptionPayNow = document.querySelector('.subscription-pay-now');
    if (subscriptionPayNow) {
        subscriptionPayNow.addEventListener('click', async (e) => {
            e.preventDefault();

            const subscriptionId = e.target.dataset.subscriptionId;
            const couponCode     = couponCodeElem ? couponCodeElem.value : '';

            payNow(subscriptionId, e.target, couponCode);
        });
    }

    /**
     * Pay for pending subscription
     * 
     * @param {number} subscriptionId subscription id
     * @param {HTMLElement} target The target HTML element that triggered the payment request.
     * @param {string} [couponCode=''] The coupon code to apply (optional).
     * 
     * @returns {void}
     */
    async function payNow(subscriptionId, target, couponCode = '') {
        if (!subscriptionId) {
            return;
        }

        let prevHTML = target.innerHTML;

        // Prepare form data
        const formData = new FormData();
        formData.set('action', 'subscription_pay_now');
        formData.set('subscription_id', subscriptionId);
        formData.set('affiliate_uuid', getAffiliateUUID());
        formData.set('paddle_api_type', target.dataset.paddleApiType);

        if (couponCode) {
            formData.set('coupon_code', couponCode);
            formData.set('plan_id', target.dataset.planId);
        }

        // Send request
        try {
            // Disable btn and show spinner
            target.innerHTML = `${spinnerElem}`;
            target.setAttribute('disabled', true);

            const res = await ajaxHandler(formData);
       
            if (res) {
                const { data, success } = res;
                if (success) {
                    target.dataset.paddleApiType === 'classic' ? openPaddleCheckout(data) : openPaddleCheckoutForBilling(data);
                } else {
                    toast.error(data);
                }
            } else {
                toast.error('Something went wrong! Please try again later.');
            }
        } catch (error) {
            toast.error('Something went wrong! Please try again later.');
        } finally {
            target.innerHTML = `${prevHTML}`;
            target.removeAttribute('disabled');
        }
    }

    /**
     * Handle a subscription
     * 
     * @param {number} productPackageId The product package id
     * @param {number} planId The payment gateway plan id for subscription
     * 
     * @returns {void}
     */
    async function handleSubscription(paddlePlanId, planId, couponCode, target) {
        if (!planId) {
            toast.error('Invalid plan id');
            return;
        }

        // Prepare form data
        const formData = new FormData();
        formData.set('action', 'products_subscription');
        formData.set('plan_id', planId);
        formData.set('paddle_plan_id', paddlePlanId);
        //formData.set('affiliate_uuid', affiliateUuid);
        formData.set('coupon_code', couponCode);
        formData.set('affiliate_url', window.location.href);
        formData.set('paddle_api_type', target.dataset.paddleApiType);


        let prevHTML = target.innerHTML;

        // Send request
        try {

            // Disable btn and show spinner
            target.setAttribute('disabled', true);
            target.innerHTML = `${spinnerElem}`;

            const res = await ajaxHandler(formData);

            if (res) {
                const { data, success } = res;
                if (success) {

                    (target.dataset.paddleApiType === 'classic') ? openPaddleCheckout(data) : openPaddleCheckoutForBilling(data)
        
                } else {
                    toast.error(data);
                }
            } else {
                toast.error('Something went wrong! Please try again later.');
            }
        } catch (error) {
            toast.error('Something went wrong! Please try again later.');
        } finally {
            target.removeAttribute('disabled');
            target.innerHTML = `${prevHTML}`;
        }
    }

    /**
     * Update a subscription auto renew
     * 
     * @param {number} orderId The ID of the order to cancel
     * 
     * @returns {void}
     */
    async function updateAutoRenew(planId, paddleSubscriptionId, subscriptionId, target, isEnable) {

        const paddleApiType = target.dataset.paddleApiType;
        // Prepare form data
        const formData = new FormData();
        formData.set('action', 'products_subscription_auto_renew_update');
        formData.set('paddle_subscription_id', paddleSubscriptionId);
        formData.set('subscription_id', subscriptionId);
        formData.set('plan_id', planId);
        formData.set('is_enable', isEnable);
        formData.set('paddle_api_type', paddleApiType);

        let prevHTML = target.innerHTML;

        try {
            // Disable button & show spinner
            target.setAttribute('disabled', true);
            target.innerHTML = `${spinnerElem}`;

            const res = await ajaxHandler(formData);
            if (res) {
                const { data, success } = res;
                if (success) {
                    if (data.url) {
                        openPaddleCheckout(data.url);
                    } else {
                        toast.success(data);
                        target.checked = isEnable;
                    }
                } else {
                    toast.error(data);
                }
            } else {
                toast.error(data);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            target.removeAttribute('disabled');
            target.innerHTML = `${prevHTML}`;
        }
    }

    // Handle upgrade subscription
    const upgradeSubscriptionForm = document.getElementById('subscription-upgrade-form');
    if (upgradeSubscriptionForm) {
        upgradeSubscriptionForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const submitBtn = upgradeSubscriptionForm.querySelector('[type=submit]');
            const target = submitBtn;

            // Prepare form data
            const formData = new FormData(upgradeSubscriptionForm);

            // Show alert if plan id & new plan id same.
            if (formData.get('plan_id') === formData.get('new_plan_id')) {
                return toast.error('Select a new plan to upgrade.');
            }

            const upgradeType = formData.get('upgrade_type');
            if (upgradeType === 'lifetime') {
                formData.set('action', 'products_lifetime_subscription_upgrade');
            } else {
                formData.set('action', 'products_subscription_upgrade');
            }

            let prevHTML = target.innerHTML;

            // Send request
            try {
                // Disable button & show spinner
                target.setAttribute('disabled', true);
                target.innerHTML = `${spinnerElem}`;

                const res = await ajaxHandler(formData);
                if (res) {
                    const { data, success } = res;
                    if (success) {
                        if (data.url || data.id) {
                            upgradeModalBootstrap.close();

                            data.url ? openPaddleCheckout(data.url) : openPaddleCheckoutForBilling(data.id);                          
                        } else {
                            toast.success(data);
                            location.reload();
                        }
                    } else {
                        toast.error(data);
                    }
                } else {
                    toast.error('Something went wrong! Please try again later.');
                }
            } catch (error) {
                toast.error(error);
            } finally {
                target.removeAttribute('disabled');
                target.innerHTML = `${prevHTML}`;
            }
        });
    }

    /**
     * Get affiliate uud from query params
     *
     * @since 1.0.0
     *
     * @returns string
     */
    function getAffiliateUUID() {
        let affiliateUuid = '';
        // Affiliate uuid
        const queryParams = new URLSearchParams(window.location.search);

        // Check if the "affiliate" parameter exists in the URL
        if (queryParams.has('affiliate')) {
            affiliateUuid = queryParams.get('affiliate');
        }
        return affiliateUuid;
    }

    // Listen iframe event
    window.addEventListener('message', function (event) {
        // Handle the message received from the iframe
        const iframeButton = document.querySelector('button[data-testid=wideOverlayCloseIcon]');
        if (iframeButton) {
            window.parent.postMessage('ButtonClicked', '*');
            iframeButton.addEventListener('click', () => {
                document.body.removeChild(document.querySelector('iframe'));
            });
        }
    });

    /**
     * Opens a Paddle Classic Checkout for one-time or subscription purchase.
     *
     * @param {Object} data - The Paddle checkout configuration object
     */
    function openPaddleCheckout(data) {
        if ('live' !== environment.toLowerCase()) {
            Paddle.Environment.set(environment.toLowerCase());
        }

        Paddle.Setup(
            {
                vendor: Number(vendor_id),
                eventCallback: function (data) {
                    const passthroughData = JSON.parse(data.eventData.checkout.passthrough);
                    if (passthroughData && data.event === 'Checkout.Complete') {
                        if (passthroughData.identifier === 'lifetime_plan_upgrade') {
                            // Reload page for lifetime plan
                            setTimeout(() => {
                                window.location.reload();
                            }, 2000)
                        }
                    }
                }
            }
        );

        setTimeout(() => {
            Paddle.Checkout.open({ override: data })
        },
            100
        );
    }

    /**
     * Opens Paddle Billing Checkout
     *
     * @param {string} data - The Paddle checkout configuration object
     */
    function openPaddleCheckoutForBilling(data) {

        if ('live' !== environment.toLowerCase()) {
            Paddle.Environment.set(environment.toLowerCase());
        }

        const customerEmail = current_user?.user_email || '';

        Paddle.Initialize({
            token: client_side_token,
            checkout: {
                settings: {
                    displayMode: "overlay",
                    theme: "light",
                    locale: "en",
                    successUrl: platformObject.success_url,
                    showAddDiscounts: false,
                    allowDiscountRemoval: false
                }
            }
        });

        setTimeout(() => {
            const checkoutData = {
                transactionId: data,
            }
            if (customerEmail) {
                checkoutData.customer = {
                    email: customerEmail
                }
            }
            Paddle.Checkout.open(checkoutData);
        }, 100);
    }
});
